import useSize from "@react-hook/size";
import { FunctionComponent, ReactNode, useRef } from "react";
import classes from "./VerticalLabel.module.scss";

export const VerticalLabel: FunctionComponent<{
  className?: string;
  children?: ReactNode;
}> = ({ className, children }) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [contentWidth, contentHeight] = useSize(contentRef);

  return (
    <div
      className={`${classes.container} ${className}`}
      style={{ minHeight: contentWidth + "px", width: contentHeight + "px" }}
    >
      <div ref={contentRef} className={classes.content}>
        {children}
      </div>
    </div>
  );
};
